import { Dash } from '@doltech/ui/lib/figma/BlankEditor/DoTest/Dash';
import { CircleText, QuestionDisplayMode } from '@doltech/ui/lib/figma/CircleText/CircleText';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Box } from '@doltech/ui/lib/figma/Common/Box';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { DoTestShortQuestionInstance } from '../../../student-do-test/model/Question/do-test-short-question.store';

export const Main = styled(Box)`
  box-shadow: unset;
  border: unset;
  pointer-events: none;
`;

export const SentenceGrid = styled.div`
  display: grid;
  grid-template-columns: 100%;
  align-items: center;
  row-gap: 12px;

  @media ${deviceBreakpoints.mobile} {
    row-gap: 16px;
  }
`;

export const Container = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  display: block;
  color: ${colorsV2.black100};
  .question-no {
    display: inline-block;
  }
  .blank {
    display: inline-block;
    margin-left: 8px;
  }
`;

interface ShortAnswerSubjectProps {
  data: DoTestShortQuestionInstance;
}

export const ShortAnswerSubject = observer((props: ShortAnswerSubjectProps) => {
  const { data, ...rest } = props;
  if (!data) return null;
  const { sentences, no } = data;

  return (
    <Main className="dol-question short-answer" {...rest}>
      <SentenceGrid>
        {sentences.map((item, index) => {
          return (
            <Container key={item.key} id={`question-no-${no + index}`}>
              <CircleText
                displayMode={QuestionDisplayMode.QUESTION_NO_VIEW_SUBJECT}
                circleText={no + Number(item.key)}
                text={null}
                className="question-no"
              />
              <span>{item.text}</span>
              <Dash className="blank" />
            </Container>
          );
        })}
      </SentenceGrid>
    </Main>
  );
});
